import type { RouteParamValue, RouteParams } from 'vue-router'
import { CURRENCIES } from '@gifsa/language-utils/routes'

function getParam(param: RouteParamValue | RouteParamValue[] | undefined) {
  if (typeof param !== 'string') {
    throw new NotFoundError(`Invalid param ${JSON.stringify(param)} type`)
  }
  return param.toUpperCase()
}

export function processParams(params: RouteParams) {
  const {
    $masterData: { currencies },
    $lang,
  } = useNuxtApp()

  const currencyFromParam = getParam(params.currencyFrom)
  const currencyFrom = currencies.get(currencyFromParam)
  const currencyToParam = getParam(params.currencyTo)
  const currencyTo = currencies.get(currencyToParam)

  if (!currencyFrom || !currencyTo) {
    throw new NotFoundError(`Unsupported currencies: ${JSON.stringify(params)}`)
  }

  const prefix = CURRENCIES.find((r) => r.lang === $lang)?.url
  if (!prefix) {
    throw new NotFoundError(`Unsupported language: ${$lang}`)
  }
  const slug = `${prefix}${currencyFrom.iso.toLowerCase()}/${currencyTo.iso.toLowerCase()}`
  const pattern = `${prefix}%CURRENCY_FROM_ISO%/%CURRENCY_TO_ISO%`

  return { slug, pattern, currencyFrom, currencyTo }
}
